export default [{
  path: 'cuenta',
  component: function component() {
    return import('pages/account/Index.vue');
  },
  children: [{
    path: '',
    name: 'account',
    component: function component() {
      return import('pages/account/GeneralData.vue');
    },
    meta: {
      auth: true,
      title: 'Perfil'
    }
  }, {
    path: 'compra',
    name: 'purchases',
    component: function component() {
      return import('pages/account/Purchases.vue');
    },
    meta: {
      title: 'Compras',
      auth: true
    }
  }, {
    path: 'direccion',
    name: 'shipment',
    component: function component() {
      return import('pages/account/Address.vue');
    },
    meta: {
      title: 'Direcciones',
      auth: true
    }
  }, {
    path: 'facturacion',
    name: 'billing',
    component: function component() {
      return import('pages/account/Billing.vue');
    },
    meta: {
      title: 'Facturación',
      auth: true
    }
  }]
}];